import { NSARouterMakerResult } from "namirasoft-account-react";
import { NSBoxBoolean, NSLabel, NSRow } from "namirasoft-site-react";
import { Component, createRef, RefObject } from "react";
import { ExpertRouterProps } from "../ExpertRouterProps";
import Styles from "./ServerSelection.module.css";

interface Server
{
    id: string;
    title: string;
    description: string;
    image: string;
}

let servers: Server[] = [
    // { id: "1", title: "Server 1", description: "Lorem ipsum dolor sit", image: "https://static.namirasoft.com/image/namirasoft/expert/entity/server/base.webp" },
    // { id: "2", title: "Server 2", description: "Lorem ipsum dolor sit", image: "https://static.namirasoft.com/image/namirasoft/expert/entity/server/base.webp" },
    // { id: "3", title: "Server 3", description: "Lorem ipsum dolor sit", image: "https://static.namirasoft.com/image/namirasoft/expert/entity/server/base.webp" },
    // { id: "4", title: "Server 4", description: "Lorem ipsum dolor sit", image: "https://static.namirasoft.com/image/namirasoft/expert/entity/server/base.webp" },
]

interface ServerSelectionProps extends NSARouterMakerResult, ExpertRouterProps { }

interface ServerSelectionState
{
    selected?: { index: number, server: Server }
}

class ServerSelection extends Component<ServerSelectionProps, ServerSelectionState>
{
    NSBoxBoolean_Refs: RefObject<NSBoxBoolean>[];

    constructor(props: ServerSelectionProps)
    {
        super(props);
        this.state = {};
        this.NSBoxBoolean_Refs = servers.map(() => createRef<NSBoxBoolean>());
    }

    override render()
    {
        return (
            <NSRow classList={["flex-row flex-wrap align-items-stretch"]}>
                {
                    servers.map((server, index) => (
                        <div
                            key={server.id}
                            role="checkbox"
                            aria-checked={false}
                            className={`${Styles.ns_server_item} ${this.state.selected?.index === index ? Styles.ns_active : ""}`}
                            onClick={() =>
                            {
                                this.NSBoxBoolean_Refs[this.state.selected?.index ?? -1]?.current?.setValue(false);

                                let checkbox = this.NSBoxBoolean_Refs[index].current;
                                let checked = checkbox?.getValueNull() ?? false;
                                checkbox?.setValue(!checked, () =>
                                {
                                    this.setState((prev) => ({ selected: prev.selected?.index !== index ? { index, server } : undefined }));
                                });
                            }}
                        >
                            <img src={server.image} width={64} height={64} alt="Server" />
                            <NSLabel
                                title={server.title}
                                description={server.description}
                                classList={[Styles.ns_server_item_label]}
                            />
                            <NSBoxBoolean
                                ref={this.NSBoxBoolean_Refs[index]}
                                title=""
                                required={false}
                                hideHeader
                                classList={[Styles.ns_server_item_check]}
                            />
                        </div>
                    ))
                }
            </NSRow>
        );
    }
}

export default ServerSelection;